<template>
    <v-row>
        <v-col>
            <v-text-field label="담당자명" v-model="inputData.workerName" v-bind="inputProps" />
        </v-col>
        <v-col>
            <v-text-field label="직책" v-model="inputData.workerTitle" v-bind="inputProps" />
        </v-col>
    </v-row>
</template>

<script>
const inputProps = {
    outlined: true,
    dense: true,
    "hide-details": true,
    persistentPlaceholder: true,
    class: "rounded-0",
};

export default {
    props: ["value"],
    data() {
        return {
            inputData: {
                workerName: null,
                workerTitle: null,
            },
            inputProps,
        };
    },
    methods: {
        init() {
            const { workerName, workerTitle } = this.value;
            this.inputData.workerName = workerName;
            this.inputData.workerTitle = workerTitle;
        },
        sync() {
            const { workerName, workerTitle } = this.inputData;
            this.$emit("input", { ...this.value, workerName, workerTitle });
        },
    },
    mounted() {
        if (this.value?.workerName) this.init();
    },
    watch: {
        "value.workerName"() {
            if (this.value.workerName !== this.inputData.workerName) this.init();
        },
        "value.workerTitle"() {
            if (this.value.workerTitle !== this.inputData.workerTitle) this.init();
        },
        "inputData.workerName"() {
            if (this.value.workerName !== this.inputData.workerName) this.sync();
        },
        "inputData.workerTitle"() {
            if (this.value.workerTitle !== this.inputData.workerTitle) this.sync();
        },
    },
};
</script>

<style></style>
